module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "payment-detail"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("公司列表")]), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addCompany
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增公司")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "company-list"
    }
  }, [(_vm.isEmptyCompanies) ? _c('div', {
    staticClass: "company-row"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "flex": "1 0 100%"
    }
  }, [_vm._v("暂无公司信息，请先新增公司")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.$store.state.auth.companies), function(company, index) {
    return (!_vm.isEmptyCompanies) ? _c('div', {
      staticClass: "company-row",
      class: {
        selected: _vm.selectedIndex === index
      },
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "comdetail_l"
    }, [_c('span', {
      staticClass: "company-name"
    }, [_vm._v(_vm._s(company.name))]), _vm._v(" "), _c('span', {
      staticClass: "company-rep"
    }, [_vm._v(_vm._s(company.legalPerson))]), _vm._v(" "), _c('span', {
      staticClass: "company-addr"
    }, [_vm._v(_vm._s(company.address))]), _vm._v(" "), _c('span', {
      staticClass: "insured"
    }, [(company.isInsured) ? _c('span', [_vm._v("参保人信息")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "default"
    }, [(company.isDefault) ? _c('span', [_vm._v("默认")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "r",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [(!company.isInsured) ? _c('span', {
      staticClass: "edit-btn",
      on: {
        "click": function($event) {
          _vm.edit(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-edit"
    }), _vm._v("修改")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "delete-btn",
      on: {
        "click": function($event) {
          _vm.deleteCompany(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    }), _vm._v("删除")])])]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-0bc28e77!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanySelection.vue
// module id = 1009
// module chunks = 40